import(/* webpackMode: "eager" */ "/vercel/path0/apps/onboarding/src/app/global-error.tsx");
